import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { BehaviorSubject } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { UserService } from '../../tab1/user.service';

export enum CRM_PLATFORM {
  ZOHO = 'zoho',
  HUBSPOT = 'hubspot',
  SALESFORCE = 'salesforce',
  RD = 'rdcrm',
  PIPEDRIVE = 'pipedrive',
  ATENDARE = 'atendare',
  NECTAR = 'nectarcrm',
  DYNAMICS = 'dynamics'
}

export interface PipelineSettings {
  pipelineID: string | number;
  stageID: string | number;
  sourceID?: string | number;
}

@Injectable({ providedIn: 'root' })
export class CrmService {
  currentCRM = new BehaviorSubject<string | null>(null);

  constructor(
    private fireFunctions: Functions,
    private userService: UserService,
    loginService: LoginService
  ) {
    loginService.user$.subscribe((user) => {
      if (user) this.getCurrentCRM().then();
    });
  }

  async getCurrentCRM() {
    /** aguarda até ter um cardID */
    this.userService.cardID$.subscribe((cardID) => {
      if (cardID) {
        const req = httpsCallable(this.fireFunctions, 'currentCRMIntegration');
        req({ cardID: this.userService.getCardID() }).then((result) => {
          if ((result.data as any).success) {
            this.currentCRM.next((result.data as any).platform as string);
          }
        });
      }
    });
  }
}
